import { DateTime } from "luxon";
import { ChartCell } from "../ChartCell";
import { MonthLabel, Period, Resource } from "./styles";
import { HashLink } from "react-router-hash-link/dist/react-router-hash-link.cjs.production";

const names = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];


function splitTimeInMonthsAndDays(startDate, endDate) {
  const result = [];

  let currentDate = startDate.startOf('day');
  const end = endDate.startOf('day');

  while (currentDate <= end) {
    const monthEnd = currentDate.endOf('month');
    // const daysInMonth = monthEnd.diff(currentDate, 'days').days + 1;
    const monthDays = [];

    while (currentDate <= monthEnd && currentDate <= end) {
      monthDays.push(currentDate);
      currentDate = currentDate.plus({ days: 1 });
    }

    result.push(monthDays);
  }

  return result;
}



export function initFirstRow(first_month, last_month, currentDate) {
  let elements = [];
  let i = 0;

  elements.push(<div key={"fr" + i++} className="gantt-row-resource top-left-month"></div>);
  const current = [currentDate.getFullYear(), currentDate.getMonth()].join("-");

  const month = new Date(first_month);



  for (month; month <= last_month; month.setMonth(month.getMonth() + 1)) {
    const format = [month.getFullYear(), month.getMonth()].join("-");

    elements.push(
      <Period className="gantt-month-period" key={"fr" + i++}>
        <MonthLabel isActualMonth={format === current}>
          {names[month.getMonth()]}
        </MonthLabel>
      </Period>
    );
  }


  return elements;
}

export function getFormattedDate(date) {
  return JSON.stringify(
    [date.getFullYear(), date.getMonth(), date.getDate()].join("-")
  );
}


export function initSecondRow({
  first_month,
  dateTime,
}) {
  let elements = [];
  let i = 0;

  const actualDate = DateTime.now();
  // Resources são o header do eixo X da linha do tempo
  elements.push(
    <Resource
      key={"sr" + i++}
      className="gantt-row-resource top-left-day"
    />

  );


  // const firstMonth = DateTime.fromJSDate(getInitDate(minDate))
  const firstMonth = DateTime.fromJSDate(first_month);
  const lastMonth = DateTime.fromJSDate(dateTime.dateTo); //maxDate + 10 de offset

  const diffInMonths = lastMonth.diff(firstMonth, 'months').months;


  let dates;

  if (diffInMonths < 1) {
    dates = splitTimeInMonthsAndDays(firstMonth, lastMonth.endOf('month'))
  } else {
    dates = splitTimeInMonthsAndDays(firstMonth, lastMonth)
  }


  //Iterando Meses
  for (const monthDays of dates) {
    let days = [];

    //Iterando Dias
    for (const day of monthDays) {
      let newDate = day.toISODate();

      //Primeira linha
      days.push(
        <Period
          key={"sr" + i++}
          className="gantt-day-period"
          data={newDate}
          id={newDate === actualDate.toISODate() ? "currentDate" : null}
          status={newDate === actualDate}
          style={{
            borderTop: "none",

          }}
        >
          <span>{day.day}</span>

        </Period>
      );

    }

    //Segunda Linha em diante
    elements.push(
      <Period
        key={"sr" + i++}
        className="gantt-row-period all-days"
      >
        {days}
      </Period>
    );


  }
  return elements;
}

const scrollWithOffset = (el, ganttContainer, type) => {


  const baseXOffset = type === 'task' || type === 'timer' ? -230 : -280;



  const xCoordinate = el.getBoundingClientRect().left -
    ganttContainer.current.getBoundingClientRect().left + ganttContainer.current.scrollLeft;

  const updateLeft = xCoordinate + baseXOffset
  const xOffset = updateLeft > 0 ? baseXOffset : 0;

  ganttContainer.current.scrollTo({ left: xCoordinate + xOffset, behavior: 'smooth' });
}


export function initGanttRows({ first_month, last_month, jobs, theme, dateTime, ganttContainer }) {
  let elements = [];
  let i = 0;

  const resources = jobs;



  const lastTaskDate = dateTime.dateTo;


  const minimalContent = resources.length > 7 ? resources.length : 7;


  const newArray = Array.from({ length: minimalContent }, (_, index) => resources[index] || 'null');

  // console.log(newArray);


  const axisJobsStyle = {
    gridTemplateColumns: `${theme.axisResourceWidth} repeat(1,1fr)`,

  }

  //Pelo numero de tarefas
  newArray.forEach((resource) => {

    // Resources são o header do eixo X da linha do tempo
    elements.push(
      <Resource
        status={resource.status}
        key={"gr" + Math.random()}
        style={{
          ...axisJobsStyle,
          height: theme.cellHeight
        }}
        className="gantt-row-resource"
      >
        {resource !== 'null' ?
          <div >
            <HashLink
              scroll={(el) => scrollWithOffset(el, ganttContainer, resource.type)}
              title={resource.label} to={`${window.location.search}#${resource.id}`}>
              {resource.label}
            </HashLink>
          </div>
          : null}
      </Resource>
    );

    const month = new Date(first_month);


    //Varredura de mês
    for (month; month <= last_month; month.setMonth(month.getMonth() + 1)) {
      let cells = [];

      const finalDate = new Date(month.getFullYear(), month.getMonth() + 1, 0);

      const date = new Date(month);

      //Verifica se não é o último mês a ser exibido
      let currentDate =
        finalDate.getMonth() === lastTaskDate.getMonth() &&
          finalDate.getFullYear() === lastTaskDate.getFullYear() &&
          last_month - first_month !== 0
          ? lastTaskDate
          : finalDate;

      //Varredura diária
      for (date; date <= currentDate; date.setDate(date.getDate() + 1)) {
        let cell_jobs = jobs.filter(
          (job) =>
            job.id === resource.id &&
            job.start.toLocaleDateString() === date.toLocaleDateString()
        );

        cells.push(
          <ChartCell
            key={"gr" + i++}
            resource={resource}
            date={new Date(date)}
            jobs={cell_jobs}
            theme={theme}
          />
        );
      }
      elements.push(
        <Period
          key={"gr" + i++}
          className="gantt-row-period"
        >
          {cells}
        </Period>
      );

      //AS ARROWS AQUI
    }
  });

  return elements;
}
